export interface BengkungRankInfo {
  code: string;
  dbCode: string;
  bengkungName: string;
  rankTitle: string;
  module: string;
  culaCount: number;
  beltBgClass: string;
  culaBgClass: string;
  textColorClass: string;
}

export const ASMM_BENGKUNG_RANKS: BengkungRankInfo[] = [
  // Bengkung Hitam (Peringkat Tunas Pendekar - Kanak-Kanak & Terawal)
  { code: 'Hitam', dbCode: 'hitam0', bengkungName: 'Bengkung Hitam', rankTitle: 'Tunas Pendekar', module: 'Bengkung Hitam', culaCount: 0, beltBgClass: 'bg-slate-900 border border-slate-800 shadow-inner', culaBgClass: 'bg-white', textColorClass: 'text-white' },
  { code: 'Hitam 1', dbCode: 'hitam1', bengkungName: 'Bengkung Hitam (Peringkat 1)', rankTitle: 'Tunas Pendekar Muda', module: 'Bengkung Hitam', culaCount: 1, beltBgClass: 'bg-slate-900 border border-slate-800 shadow-inner', culaBgClass: 'bg-white', textColorClass: 'text-white' },
  { code: 'Hitam 2', dbCode: 'hitam2', bengkungName: 'Bengkung Hitam (Peringkat 2)', rankTitle: 'Tunas Pendekar Kanan', module: 'Bengkung Hitam', culaCount: 2, beltBgClass: 'bg-slate-900 border border-slate-800 shadow-inner', culaBgClass: 'bg-white', textColorClass: 'text-white' },
  { code: 'Hitam 3', dbCode: 'hitam3', bengkungName: 'Bengkung Hitam (Peringkat 3)', rankTitle: 'Tunas Pendekar Sulung', module: 'Bengkung Hitam', culaCount: 3, beltBgClass: 'bg-slate-900 border border-slate-800 shadow-inner', culaBgClass: 'bg-white', textColorClass: 'text-white' },

  // Bengkung Putih (Peringkat Pesilat Dewasa / Remaja)
  { code: 'Putih', dbCode: 'putih0', bengkungName: 'Bengkung Putih Kosong', rankTitle: 'Pesilat Asas', module: 'Bengkung Putih', culaCount: 0, beltBgClass: 'bg-white border border-slate-300 shadow-inner', culaBgClass: 'bg-red-600', textColorClass: 'text-slate-900' },
  { code: 'Putih 1', dbCode: 'putih1', bengkungName: 'Bengkung Putih (Peringkat 1)', rankTitle: 'Pesilat Muda', module: 'Bengkung Putih', culaCount: 1, beltBgClass: 'bg-white border border-slate-300 shadow-inner', culaBgClass: 'bg-red-600', textColorClass: 'text-slate-900' },
  { code: 'Putih 2', dbCode: 'putih2', bengkungName: 'Bengkung Putih (Peringkat 2)', rankTitle: 'Pesilat Kanan', module: 'Bengkung Putih', culaCount: 2, beltBgClass: 'bg-white border border-slate-300 shadow-inner', culaBgClass: 'bg-red-600', textColorClass: 'text-slate-900' },
  { code: 'Putih 3', dbCode: 'putih3', bengkungName: 'Bengkung Putih (Peringkat 3)', rankTitle: 'Pesilat Sulung', module: 'Bengkung Putih', culaCount: 3, beltBgClass: 'bg-white border border-slate-300 shadow-inner', culaBgClass: 'bg-red-600', textColorClass: 'text-slate-900' },

  // Bengkung Merah
  { code: 'Merah', dbCode: 'merah0', bengkungName: 'Bengkung Merah Kosong', rankTitle: 'Pembantu Jurulatih Asas', module: 'Bengkung Merah', culaCount: 0, beltBgClass: 'bg-red-600 border border-red-700 shadow-inner', culaBgClass: 'bg-[#fff000]', textColorClass: 'text-white' },
  { code: 'Merah 1', dbCode: 'merah1', bengkungName: 'Bengkung Merah (Peringkat 1)', rankTitle: 'Pembantu Jurulatih Muda', module: 'Bengkung Merah', culaCount: 1, beltBgClass: 'bg-red-600 border border-red-700 shadow-inner', culaBgClass: 'bg-[#fff000]', textColorClass: 'text-white' },
  { code: 'Merah 2', dbCode: 'merah2', bengkungName: 'Bengkung Merah (Peringkat 2)', rankTitle: 'Pembantu Jurulatih Kanan', module: 'Bengkung Merah', culaCount: 2, beltBgClass: 'bg-red-600 border border-red-700 shadow-inner', culaBgClass: 'bg-[#fff000]', textColorClass: 'text-white' },
  { code: 'Merah 3', dbCode: 'merah3', bengkungName: 'Bengkung Merah (Peringkat 3)', rankTitle: 'Pembantu Jurulatih Sulung', module: 'Bengkung Merah', culaCount: 3, beltBgClass: 'bg-red-600 border border-red-700 shadow-inner', culaBgClass: 'bg-[#fff000]', textColorClass: 'text-white' },

  // Bengkung Kuning
  { code: 'Kuning 0', dbCode: 'kuning0', bengkungName: 'Bengkung Kuning Kosong', rankTitle: 'Jurulatih', module: 'Bengkung Kuning', culaCount: 0, beltBgClass: 'bg-[#fff000] border border-yellow-400 shadow-inner', culaBgClass: 'bg-black', textColorClass: 'text-slate-900' },
  { code: 'Kuning 1', dbCode: 'kuning1', bengkungName: 'Bengkung Kuning (Cula 1)', rankTitle: 'Jurulatih Muda', module: 'Bengkung Kuning', culaCount: 1, beltBgClass: 'bg-[#fff000] border border-yellow-400 shadow-inner', culaBgClass: 'bg-black', textColorClass: 'text-slate-900' },
  { code: 'Kuning 2', dbCode: 'kuning2', bengkungName: 'Bengkung Kuning (Cula 2)', rankTitle: 'Jurulatih Muda', module: 'Bengkung Kuning', culaCount: 2, beltBgClass: 'bg-[#fff000] border border-yellow-400 shadow-inner', culaBgClass: 'bg-black', textColorClass: 'text-slate-900' },
  { code: 'Kuning 3', dbCode: 'kuning3', bengkungName: 'Bengkung Kuning (Cula 3)', rankTitle: 'Jurulatih Muda', module: 'Bengkung Kuning', culaCount: 3, beltBgClass: 'bg-[#fff000] border border-yellow-400 shadow-inner', culaBgClass: 'bg-black', textColorClass: 'text-slate-900' },
  { code: 'Kuning 4', dbCode: 'kuning4', bengkungName: 'Bengkung Kuning (Cula 4)', rankTitle: 'Jurulatih Kanan', module: 'Bengkung Kuning', culaCount: 4, beltBgClass: 'bg-[#fff000] border border-yellow-400 shadow-inner', culaBgClass: 'bg-black', textColorClass: 'text-slate-900' },
  { code: 'Kuning 5', dbCode: 'kuning5', bengkungName: 'Bengkung Kuning (Cula 5)', rankTitle: 'Jurulatih Kanan', module: 'Bengkung Kuning', culaCount: 5, beltBgClass: 'bg-[#fff000] border border-yellow-400 shadow-inner', culaBgClass: 'bg-black', textColorClass: 'text-slate-900' },
  { code: 'Kuning 6', dbCode: 'kuning6', bengkungName: 'Bengkung Kuning (Cula 6)', rankTitle: 'Jurulatih Kanan', module: 'Bengkung Kuning', culaCount: 6, beltBgClass: 'bg-[#fff000] border border-yellow-400 shadow-inner', culaBgClass: 'bg-black', textColorClass: 'text-slate-900' },
  { code: 'Kuning 7', dbCode: 'kuning7', bengkungName: 'Bengkung Kuning (Cula 7)', rankTitle: 'Jurulatih Sulung', module: 'Bengkung Kuning', culaCount: 7, beltBgClass: 'bg-[#fff000] border border-yellow-400 shadow-inner', culaBgClass: 'bg-black', textColorClass: 'text-slate-900' },

  // Bengkung Biru (#0000ff) - Tanpa Cula (Peringkat Pendekar)
  { code: 'Biru', dbCode: 'biru', bengkungName: 'Bengkung Biru Samudera', rankTitle: 'Pendekar Muda (Dewan Pendekar)', module: 'Bengkung Biru Samudera', culaCount: 0, beltBgClass: 'bg-[#0000ff] border border-blue-700 shadow-inner', culaBgClass: 'bg-white', textColorClass: 'text-white' },

  // Guru Utama
  { code: 'Guru Utama', dbCode: 'guru_utama', bengkungName: 'Bengkung Guru Utama', rankTitle: 'Guru Utama Perguruan ASMM', module: 'Kepimpinan Perguruan', culaCount: 7, beltBgClass: 'bg-gradient-to-r from-yellow-300 via-[#fff000] to-yellow-400 border border-yellow-500 shadow-inner', culaBgClass: 'bg-black', textColorClass: 'text-slate-900' }
];

export interface BeltColorPreset {
  id: string;
  name: string;
  module: string;
  beltBgClass: string;
  culaBgClass: string;
  textColorClass: string;
  sampleColor: string;
}

export const BELT_COLOR_PRESETS: BeltColorPreset[] = [
  {
    id: 'hitam',
    name: 'Hitam (Cula Putih)',
    module: 'Bengkung Hitam',
    beltBgClass: 'bg-slate-900 border border-slate-800 shadow-inner',
    culaBgClass: 'bg-white',
    textColorClass: 'text-white',
    sampleColor: '#0f172a'
  },
  {
    id: 'putih',
    name: 'Putih (Cula Merah)',
    module: 'Bengkung Putih',
    beltBgClass: 'bg-white border border-slate-300 shadow-inner',
    culaBgClass: 'bg-red-600',
    textColorClass: 'text-slate-900',
    sampleColor: '#ffffff'
  },
  {
    id: 'merah',
    name: 'Merah (Cula Kuning)',
    module: 'Bengkung Merah',
    beltBgClass: 'bg-red-600 border border-red-700 shadow-inner',
    culaBgClass: 'bg-[#fff000]',
    textColorClass: 'text-white',
    sampleColor: '#dc2626'
  },
  {
    id: 'kuning',
    name: 'Kuning (Cula Hitam)',
    module: 'Bengkung Kuning',
    beltBgClass: 'bg-[#fff000] border border-yellow-400 shadow-inner',
    culaBgClass: 'bg-black',
    textColorClass: 'text-slate-900',
    sampleColor: '#fff000'
  },
  {
    id: 'biru',
    name: 'Biru (Cula Putih)',
    module: 'Bengkung Biru Samudera',
    beltBgClass: 'bg-[#0000ff] border border-blue-700 shadow-inner',
    culaBgClass: 'bg-white',
    textColorClass: 'text-white',
    sampleColor: '#0000ff'
  },
  {
    id: 'hijau',
    name: 'Hijau (Cula Putih)',
    module: 'Bengkung Hijau',
    beltBgClass: 'bg-emerald-600 border border-emerald-700 shadow-inner',
    culaBgClass: 'bg-white',
    textColorClass: 'text-white',
    sampleColor: '#059669'
  },
  {
    id: 'emas',
    name: 'Emas (Guru Utama)',
    module: 'Kepimpinan Perguruan',
    beltBgClass: 'bg-gradient-to-r from-yellow-300 via-[#fff000] to-yellow-400 border border-yellow-500 shadow-inner',
    culaBgClass: 'bg-black',
    textColorClass: 'text-slate-900',
    sampleColor: '#eab308'
  }
];

export const BENGKUNG_RANKS_STORAGE_KEY = 'asmm_bengkung_ranks_custom_v1';

/**
 * Retrieves the live custom bengkung ranks from localStorage, falling back to ASMM_BENGKUNG_RANKS.
 */
export function getCustomBengkungRanks(): BengkungRankInfo[] {
  if (typeof window === 'undefined') return [...ASMM_BENGKUNG_RANKS];
  try {
    const raw = localStorage.getItem(BENGKUNG_RANKS_STORAGE_KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed) && parsed.length > 0) {
        return parsed.map((item: any) => {
          const def = ASMM_BENGKUNG_RANKS.find(d => d.code === item.code || d.dbCode === item.dbCode);
          let code = item.code || def?.code || '';
          let rankTitle = item.rankTitle || def?.rankTitle || '';

          // Normalize Kuning rankings:
          // Kuning 0 (Jurulatih), Kuning 1-3 (Jurulatih Muda), Kuning 4-6 (Jurulatih Kanan), Kuning 7 (Jurulatih Sulung)
          const normDb = (item.dbCode || def?.dbCode || '').toLowerCase();
          const normCode = code.toLowerCase().replace(/[^a-z0-9]/g, '');
          if (normDb === 'kuning0' || normCode === 'kuning' || normCode === 'kuning0') {
            code = 'Kuning 0';
            rankTitle = 'Jurulatih';
          } else if (normDb === 'kuning1' || normDb === 'kuning2' || normDb === 'kuning3') {
            rankTitle = 'Jurulatih Muda';
          } else if (normDb === 'kuning4' || normDb === 'kuning5' || normDb === 'kuning6') {
            rankTitle = 'Jurulatih Kanan';
          } else if (normDb === 'kuning7') {
            rankTitle = 'Jurulatih Sulung';
          }

          return {
            code,
            dbCode: item.dbCode || def?.dbCode || '',
            bengkungName: item.bengkungName || def?.bengkungName || code || '',
            rankTitle,
            module: item.module || def?.module || '',
            culaCount: typeof item.culaCount === 'number' ? item.culaCount : (def?.culaCount ?? 0),
            beltBgClass: item.beltBgClass || def?.beltBgClass || 'bg-[#fff000] border border-yellow-400 shadow-inner',
            culaBgClass: item.culaBgClass || def?.culaBgClass || 'bg-black',
            textColorClass: item.textColorClass || def?.textColorClass || 'text-slate-900'
          };
        });
      }
    }
  } catch (e) {
    console.error('Failed to parse custom bengkung ranks:', e);
  }
  return [...ASMM_BENGKUNG_RANKS];
}

/**
 * Standardizes raw bengkung string to compact dbCode e.g. "Merah 2 (Pembantu Jurulatih Kanan)" -> "merah2"
 */
export function toDbBengkungCode(bengkung: string): string {
  if (!bengkung) return 'putih1';
  const clean = bengkung.replace(/\s*\([^)]*\)/g, '').toLowerCase().replace(/[^a-z0-9_]/g, '');

  if (clean === 'putih' || clean === 'putih0') return 'putih0';
  if (clean === 'hitam' || clean === 'hitam0') return 'hitam0';
  if (clean === 'merah' || clean === 'merah0') return 'merah0';
  if (clean === 'kuning' || clean === 'kuning0') return 'kuning0';
  if (clean.includes('biru')) return 'biru';

  const customRanks = getCustomBengkungRanks();
  const matched = customRanks.find(r => r.dbCode === clean || clean.includes(r.dbCode));
  if (matched) return matched.dbCode;

  if (clean.includes('putih')) {
    const num = clean.replace(/[^0-9]/g, '') || '0';
    return num === '0' ? 'putih0' : `putih${num}`;
  }
  if (clean.includes('hitam')) {
    const num = clean.replace(/[^0-9]/g, '') || '0';
    return `hitam${num}`;
  }
  if (clean.includes('merah')) {
    const num = clean.replace(/[^0-9]/g, '') || '0';
    return `merah${num}`;
  }
  if (clean.includes('kuning')) {
    const num = clean.replace(/[^0-9]/g, '') || '0';
    return `kuning${num}`;
  }
  if (clean.includes('guru')) return 'guru_utama';
  return 'putih0';
}

/**
 * Cleans bengkung string and converts dbCode to display title e.g. "kuning0" -> "Kuning"
 */
export function cleanBengkungTitle(bengkung: string): string {
  if (!bengkung) return 'Putih';
  const rawClean = bengkung.replace(/\s*\([^)]*\)/g, '').trim();
  const normalized = rawClean.toLowerCase().replace(/[^a-z0-9_]/g, '');

  if (normalized === 'putih0' || normalized === 'putih') return 'Putih';
  if (normalized === 'hitam0' || normalized === 'hitam') return 'Hitam';
  if (normalized === 'merah0' || normalized === 'merah') return 'Merah';
  if (normalized === 'kuning0' || normalized === 'kuning') return 'Kuning 0';
  if (normalized === 'biru') return 'Biru';

  const customRanks = getCustomBengkungRanks();
  const matched = customRanks.find(r => r.dbCode === normalized || r.code.toLowerCase() === rawClean.toLowerCase());
  if (matched) return matched.code;

  return rawClean;
}

/**
 * Resolves official Silat rank title from bengkung string or dbCode
 */
export function getSilatRankFromBengkung(bengkung: string): string {
  if (!bengkung) return 'Pesilat Asas';

  const normalized = bengkung.replace(/\s*\([^)]*\)/g, '').toLowerCase().replace(/[^a-z0-9_]/g, '');

  // Check if rank title is already in parentheses e.g. "Merah 3 (Pembantu Jurulatih Sulung)"
  const match = bengkung.match(/\(([^)]+)\)/);
  if (match && match[1]) {
    const rawInside = match[1].trim();
    // Normalize legacy Kuning rank titles (Darjah 1..7 / Penolong Jurulatih) to official ASMM standards
    if (normalized.includes('kuning') || rawInside.toLowerCase().includes('jurulatih')) {
      if (normalized === 'kuning' || normalized === 'kuning0' || rawInside.toLowerCase().includes('penolong jurulatih')) return 'Jurulatih';
      if (normalized.includes('kuning1') || normalized.includes('kuning2') || normalized.includes('kuning3') || rawInside.match(/darjah\s*[1-3]/i)) return 'Jurulatih Muda';
      if (normalized.includes('kuning4') || normalized.includes('kuning5') || normalized.includes('kuning6') || rawInside.match(/darjah\s*[4-6]/i)) return 'Jurulatih Kanan';
      if (normalized.includes('kuning7') || rawInside.match(/darjah\s*7/i)) return 'Jurulatih Sulung';
    }
    return match[1];
  }

  const customRanks = getCustomBengkungRanks();
  const matched = customRanks.find(r => r.dbCode === normalized || r.code.toLowerCase().replace(/[^a-z0-9_]/g, '') === normalized);
  if (matched) {
    return matched.rankTitle;
  }

  if (normalized.includes('putih0') || normalized === 'putih') return 'Pesilat Asas';
  if (normalized.includes('putih1')) return 'Pesilat Muda';
  if (normalized.includes('putih2')) return 'Pesilat Kanan';
  if (normalized.includes('putih3')) return 'Pesilat Sulung';
  if (normalized.includes('hitam0') || normalized === 'hitam') return 'Tunas Pendekar';
  if (normalized.includes('merah0') || normalized === 'merah') return 'Pembantu Jurulatih Asas';
  if (normalized.includes('biru')) return 'Pendekar';
  if (normalized.includes('kuning0') || normalized === 'kuning') return 'Jurulatih';
  if (normalized.includes('kuning1') || normalized.includes('kuning2') || normalized.includes('kuning3')) return 'Jurulatih Muda';
  if (normalized.includes('kuning4') || normalized.includes('kuning5') || normalized.includes('kuning6')) return 'Jurulatih Kanan';
  if (normalized.includes('kuning7')) return 'Jurulatih Sulung';
  if (normalized.includes('guru')) return 'Guru Utama';
  return 'Pesilat Asas';
}

/**
 * Returns visual belt info (cula count, belt color, cula color) for any bengkung string or dbCode
 */
export function getBengkungVisualInfo(bengkung: string): BengkungRankInfo {
  const normalized = bengkung ? bengkung.replace(/\s*\([^)]*\)/g, '').toLowerCase().replace(/[^a-z0-9_]/g, '') : 'putih0';
  const customRanks = getCustomBengkungRanks();

  if (normalized === 'putih0' || normalized === 'putih') {
    const found = customRanks.find(r => r.dbCode === 'putih0');
    if (found) return found;
    return { code: 'Putih', dbCode: 'putih0', bengkungName: 'Bengkung Putih', rankTitle: 'Pesilat Asas', module: 'Modul Bengkung Putih', culaCount: 0, beltBgClass: 'bg-white border border-slate-300 shadow-inner', culaBgClass: 'bg-red-600', textColorClass: 'text-slate-900' };
  }
  if (normalized === 'hitam0' || normalized === 'hitam') {
    const found = customRanks.find(r => r.dbCode === 'hitam0');
    if (found) return found;
    return { code: 'Hitam', dbCode: 'hitam0', bengkungName: 'Bengkung Hitam', rankTitle: 'Tunas Pendekar', module: 'Modul Bengkung Hitam', culaCount: 0, beltBgClass: 'bg-slate-900 border border-slate-800 shadow-inner', culaBgClass: 'bg-white', textColorClass: 'text-white' };
  }
  if (normalized === 'merah0' || normalized === 'merah') {
    const found = customRanks.find(r => r.dbCode === 'merah0');
    if (found) return found;
    return { code: 'Merah', dbCode: 'merah0', bengkungName: 'Bengkung Merah', rankTitle: 'Pembantu Jurulatih Asas', module: 'Modul Bengkung Merah', culaCount: 0, beltBgClass: 'bg-red-600 border border-red-700 shadow-inner', culaBgClass: 'bg-[#fff000]', textColorClass: 'text-white' };
  }
  if (normalized === 'kuning0' || normalized === 'kuning') {
    const found = customRanks.find(r => r.dbCode === 'kuning0');
    if (found) return found;
    return { code: 'Kuning 0', dbCode: 'kuning0', bengkungName: 'Bengkung Kuning', rankTitle: 'Jurulatih', module: 'Modul Bengkung Kuning', culaCount: 0, beltBgClass: 'bg-[#fff000] border border-yellow-400 shadow-inner', culaBgClass: 'bg-black', textColorClass: 'text-slate-900' };
  }

  const matched = customRanks.find(r => r.dbCode === normalized || r.code.toLowerCase().replace(/[^a-z0-9_]/g, '') === normalized);
  if (matched) return matched;

  // Fallbacks by color keyword
  if (normalized.includes('hitam')) {
    const count = parseInt(normalized.replace(/[^0-9]/g, '')) || 0;
    return { code: count === 0 ? 'Hitam' : `Hitam ${count}`, dbCode: `hitam${count}`, bengkungName: count === 0 ? 'Bengkung Hitam' : `Bengkung Hitam ${count}`, rankTitle: 'Tunas Pendekar', module: 'Modul Bengkung Hitam', culaCount: count, beltBgClass: 'bg-slate-900 border border-slate-800 shadow-inner', culaBgClass: 'bg-white', textColorClass: 'text-white' };
  }
  if (normalized.includes('merah')) {
    const count = parseInt(normalized.replace(/[^0-9]/g, '')) || 0;
    return { code: count === 0 ? 'Merah' : `Merah ${count}`, dbCode: `merah${count}`, bengkungName: count === 0 ? 'Bengkung Merah' : `Bengkung Merah ${count}`, rankTitle: 'Pembantu Jurulatih', module: 'Modul Bengkung Merah', culaCount: count, beltBgClass: 'bg-red-600 border border-red-700 shadow-inner', culaBgClass: 'bg-[#fff000]', textColorClass: 'text-white' };
  }
  if (normalized.includes('biru')) {
    return { code: 'Biru', dbCode: 'biru', bengkungName: 'Bengkung Biru', rankTitle: 'Pendekar', module: 'Modul Bengkung Biru', culaCount: 0, beltBgClass: 'bg-[#0000ff] border border-blue-700 shadow-inner', culaBgClass: 'bg-white', textColorClass: 'text-white' };
  }
  if (normalized.includes('kuning')) {
    const count = parseInt(normalized.replace(/[^0-9]/g, '')) || 0;
    const rankTitle = count === 0 ? 'Jurulatih' : count <= 3 ? 'Jurulatih Muda' : count <= 6 ? 'Jurulatih Kanan' : 'Jurulatih Sulung';
    return { code: `Kuning ${count}`, dbCode: `kuning${count}`, bengkungName: count === 0 ? 'Bengkung Kuning' : `Bengkung Kuning ${count}`, rankTitle, module: 'Modul Bengkung Kuning', culaCount: count, beltBgClass: 'bg-[#fff000] border border-yellow-400 shadow-inner', culaBgClass: 'bg-black', textColorClass: 'text-slate-900' };
  }

  // Default Putih
  const count = parseInt(normalized.replace(/[^0-9]/g, '')) || 1;
  return { code: count === 0 ? 'Putih' : `Putih ${count}`, dbCode: `putih${count}`, bengkungName: count === 0 ? 'Bengkung Putih' : `Bengkung Putih ${count}`, rankTitle: 'Pesilat Muda', module: 'Modul Bengkung Putih', culaCount: count, beltBgClass: 'bg-white border border-slate-300 shadow-inner', culaBgClass: 'bg-red-600', textColorClass: 'text-slate-900' };
}

/**
 * Returns next target bengkung rank for Ujian Kenaikan Bengkung
 */
export function getNextBengkungRank(currentBengkung: string): string {
  const ranks = getCustomBengkungRanks();
  const currentDb = toDbBengkungCode(currentBengkung);
  const currentIndex = ranks.findIndex(r => r.dbCode === currentDb || r.code.toLowerCase() === (currentBengkung || '').toLowerCase().trim());
  if (currentIndex >= 0 && currentIndex < ranks.length - 1) {
    const nextRank = ranks[currentIndex + 1];
    // Guru Utama is a title for Pengerusi, not obtainable through ujian
    if (nextRank.code.toLowerCase().includes('guru utama')) {
      return 'Peringkat Tertinggi (Tiada Ujian)';
    }
    return nextRank.code;
  }

  const norm = (currentBengkung || '').toLowerCase().replace(/[^a-z0-9]/g, '');
  if (norm.includes('hitam0') || norm === 'hitam') return 'Hitam 1';
  if (norm.includes('hitam1')) return 'Hitam 2';
  if (norm.includes('hitam2')) return 'Hitam 3';
  if (norm.includes('hitam3')) return 'Putih';
  if (norm.includes('putih0') || norm === 'putih') return 'Putih 1';
  if (norm.includes('putih1')) return 'Putih 2';
  if (norm.includes('putih2')) return 'Putih 3';
  if (norm.includes('putih3')) return 'Merah';
  if (norm.includes('merah0') || norm === 'merah') return 'Merah 1';
  if (norm.includes('merah1')) return 'Merah 2';
  if (norm.includes('merah2')) return 'Merah 3';
  if (norm.includes('merah3')) return 'Kuning 1';
  if (norm.includes('kuning1')) return 'Kuning 2';
  if (norm.includes('kuning2')) return 'Kuning 3';
  if (norm.includes('kuning3')) return 'Kuning 4';
  if (norm.includes('kuning4')) return 'Kuning 5';
  if (norm.includes('kuning5')) return 'Kuning 6';
  if (norm.includes('kuning6')) return 'Kuning 7';
  if (norm.includes('kuning7')) return 'Biru';
  if (norm.includes('biru') || norm.includes('guru')) return 'Peringkat Tertinggi (Tiada Ujian)';
  return 'Peringkat Seterusnya';
}

/**
 * Normalizes any bengkung or section identifier to a standard dbCode (e.g. 'sec-merah2' -> 'merah2', 'Merah 2' -> 'merah2').
 */
export function normalizeBengkungCode(raw?: string): string {
  if (!raw) return '';
  const clean = raw
    .replace(/^sec-/, '')
    .replace(/\s*\([^)]*\)/g, '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9_]/g, '');

  if (clean === 'putih' || clean === 'putih0') return 'putih0';
  if (clean === 'hitam' || clean === 'hitam0') return 'hitam0';
  if (clean === 'merah' || clean === 'merah0') return 'merah0';
  if (clean === 'kuning' || clean === 'kuning0') return 'kuning0';
  if (clean.includes('biru')) return 'biru';
  if (clean.includes('guru')) return 'guru_utama';

  const customRanks = getCustomBengkungRanks();
  const matched = customRanks.find(r => r.dbCode === clean || clean === r.code.toLowerCase().replace(/[^a-z0-9_]/g, ''));
  if (matched) return matched.dbCode;

  if (clean.includes('hitam')) {
    const num = clean.replace(/[^0-9]/g, '') || '0';
    return `hitam${num}`;
  }
  if (clean.includes('putih')) {
    const num = clean.replace(/[^0-9]/g, '') || '0';
    return num === '0' ? 'putih0' : `putih${num}`;
  }
  if (clean.includes('merah')) {
    const num = clean.replace(/[^0-9]/g, '') || '0';
    return `merah${num}`;
  }
  if (clean.includes('kuning')) {
    const num = clean.replace(/[^0-9]/g, '') || '0';
    return `kuning${num}`;
  }

  return clean;
}

/**
 * Returns the numerical rank index in the ASMM bengkung hierarchy (0 to N).
 * Higher value means higher rank. Returns -1 if invalid or not specified.
 */
export function getBengkungRankIndex(bengkung?: string): number {
  if (!bengkung) return -1;
  const dbCode = normalizeBengkungCode(bengkung);
  if (!dbCode) return -1;
  const ranks = getCustomBengkungRanks();
  const idx = ranks.findIndex(r => r.dbCode === dbCode || r.code.toLowerCase() === bengkung.toLowerCase().trim());
  if (idx !== -1) return idx;

  const norm = bengkung.toLowerCase().replace(/[^a-z0-9]/g, '');
  return ranks.findIndex(r => norm.includes(r.dbCode.toLowerCase()));
}

/**
 * Checks whether a member has achieved Bengkung Kuning or above
 * (Kuning 0-7, Biru Samudera / Pendekar, Guru Utama).
 * Only Bengkung Kuning and above are permitted to examine/grade ujian bengkung.
 */
export function isBengkungKuningAndAbove(bengkung?: string | null): boolean {
  if (!bengkung) return false;
  const norm = bengkung.toLowerCase().replace(/[^a-z0-9]/g, '');
  if (
    norm.includes('kuning') ||
    norm.includes('biru') ||
    norm.includes('samudera') ||
    norm.includes('guru') ||
    norm.includes('pelangi')
  ) {
    return true;
  }
  const idx = getBengkungRankIndex(bengkung);
  const kuning0Idx = getBengkungRankIndex('kuning0');
  if (idx !== -1 && kuning0Idx !== -1) {
    return idx >= kuning0Idx;
  }
  return false;
}

/**
 * Checks whether a given sectionRank is strictly a previous level compared to memberBengkung.
 * For example: if member is Merah 2 (index 10):
 * - Merah 1 (index 9) -> true (previous)
 * - Merah 0 / Putih / Hitam -> true (previous)
 * - Merah 2 (index 10) -> false (current level)
 * - Merah 3 (index 11) -> false (future level)
 */
export function isPreviousBengkungRank(memberBengkung?: string, sectionRank?: string): boolean {
  if (!memberBengkung || !sectionRank) return false;
  const memberIdx = getBengkungRankIndex(memberBengkung);
  const sectionIdx = getBengkungRankIndex(sectionRank);
  if (memberIdx === -1 || sectionIdx === -1) return false;
  return sectionIdx < memberIdx;
}

/**
 * Helper to collect all lesson IDs from sections that belong strictly to previous bengkung levels.
 */
export function getPreviousRankLessonIds(
  memberBengkung?: string,
  sections?: Array<{ id: string; bengkungRank: string; lessons?: Array<{ id: string }> }>
): string[] {
  if (!memberBengkung || !sections || sections.length === 0) return [];
  const memberIdx = getBengkungRankIndex(memberBengkung);
  if (memberIdx <= 0) return []; // Hitam 0 has no previous levels

  const lessonIds: string[] = [];
  for (const sec of sections) {
    const secIdx = getBengkungRankIndex(sec.bengkungRank || sec.id);
    if (secIdx !== -1 && secIdx < memberIdx) {
      if (sec.lessons && Array.isArray(sec.lessons)) {
        for (const les of sec.lessons) {
          if (les.id) lessonIds.push(les.id);
        }
      }
    }
  }
  return lessonIds;
}

/**
 * Checks whether an ahli is eligible to view KURSUS TUNAS PENDEKAR (children 7-12 years old).
 * Requirements:
 * - Age must be between 7 and 12 years old.
 * - Must NOT have achieved Bengkung Putih 0 or higher.
 * Older members (age > 12) or those who achieved Putih 0 will have it hidden.
 */
export function isEligibleForTunasPendekar(
  member?: { icNo?: string; bengkung?: string; relationship?: string } | null,
  referenceYear?: number
): boolean {
  if (!member) return false;

  // Once achieved Putih 0 or higher, KURSUS TUNAS PENDEKAR is hidden
  const rankIdx = getBengkungRankIndex(member.bengkung);
  const putih0Idx = getBengkungRankIndex('putih0');
  if (rankIdx !== -1 && putih0Idx !== -1 && rankIdx >= putih0Idx) {
    return false;
  }

  // Calculate age from Malaysian IC number
  let age = 0;
  if (member.icNo) {
    const clean = member.icNo.replace(/\D/g, '');
    if (clean.length >= 2) {
      const yy = parseInt(clean.substring(0, 2), 10);
      if (!isNaN(yy)) {
        const curYear = referenceYear || new Date().getFullYear();
        const curYearShort = curYear % 100;
        const birthYear = yy <= curYearShort ? 2000 + yy : 1900 + yy;
        age = Math.max(0, curYear - birthYear);
      }
    }
  }

  // If age cannot be calculated from IC:
  if (age === 0) {
    // Non-child relationships are adults (older)
    if (member.relationship && member.relationship !== 'Anak') {
      return false;
    }
    // If bengkung is already within Hitam, allow as Tunas Pendekar learner
    const norm = (member.bengkung || '').toLowerCase();
    return norm.includes('hitam');
  }

  // Only shown to those who meet requirement: age 7 to 12
  return age >= 7 && age <= 12;
}

/**
 * Checks if a syllabus section belongs to KURSUS TUNAS PENDEKAR (Hitam).
 */
export function isTunasPendekarSection(section: { category?: string; bengkungRank?: string; id?: string }): boolean {
  if (section.category && section.category.toUpperCase().includes('TUNAS PENDEKAR')) {
    return true;
  }
  const rank = (section.bengkungRank || '').toLowerCase();
  if (rank.startsWith('hitam')) return true;
  const id = (section.id || '').toLowerCase();
  if (id.startsWith('sec-hitam')) return true;
  return false;
}

/**
 * Resolves the official martial badge image path for any bengkung rank string or dbCode
 */
export function resolveBengkungBadge(bengkung: string): string {
  if (!bengkung) return '/badges/putih0.png';
  const clean = bengkung.toLowerCase().replace(/[^a-z0-9]/g, '');

  if (clean.includes('hitam1')) return '/badges/hitam1-tunas-pendekar-muda.png';
  if (clean.includes('hitam2')) return '/badges/hitam3-tunas-pendekar-kanan.png';
  if (clean.includes('hitam3')) return '/badges/hitam2-tunas-pendekar-sulung.png';
  if (clean.includes('hitam')) return '/badges/hitam0-tunas-pendekar.png';

  if (clean.includes('putih1')) return '/badges/putih1-pesilat-muda.png';
  if (clean.includes('putih2')) return '/badges/putih2-pesilat-kanan.png';
  if (clean.includes('putih3')) return '/badges/putih3-pesilat-sulung.png';
  if (clean.includes('putih')) return '/badges/putih0.png';

  if (clean.includes('merah1')) return '/badges/merah1-pembantu-jurulatih-muda.png';
  if (clean.includes('merah2')) return '/badges/merah2-pembantu-jurulatih-kanan.png';
  if (clean.includes('merah3')) return '/badges/merah3-pembantu-jurulatih-sulung.png';
  if (clean.includes('merah')) return '/badges/merah0-pembantu-jurulatih.png';

  if (clean.includes('kuning1')) return '/badges/kuning1-junior-instructor-jurulatih-muda.png';
  if (clean.includes('kuning2')) return '/badges/kuning2-2nd-degree-instructor-jurulatih.png';
  if (clean.includes('kuning3')) return '/badges/kuning3-3rd-degree-instructor-jurulatih.png';
  if (clean.includes('kuning4')) return '/badges/kuning4-4th-degree-instructor-jurulatih.png';
  if (clean.includes('kuning5')) return '/badges/kuning5-5th-degree-instructor-jurulatih-kanan.png';
  if (clean.includes('kuning6')) return '/badges/kuning6-6th-degree-instructor-jurulatih-kanan.png';
  if (clean.includes('kuning7')) return '/badges/kuning7-7th-degree-instructor-jurulatih-sulung.png';
  if (clean.includes('kuning')) return '/badges/kuning0-penolong-jurulatih.png';

  if (clean.includes('biru')) return '/badges/biru.png';
  if (clean.includes('guru')) return '/badges/guruUtama.png';

  return '/badges/putih0.png';
}
